/**
 * Attribute name constants
 */
export const NavEnterpriseMenuItemAttr = {
    HREF: 'href',
    LABEL: 'label',
    ICON: 'icon',
    ACTIVE: 'active',
    TARGET: 'target',
    ARIA_LABEL: 'aria-label',
    ARIA_CURRENT: 'aria-current',
    ARIA_HIDDEN: 'aria-hidden',
    REL: 'rel',
} as const

/**
 * Query selectors
 */
export const NavEnterpriseMenuItemSelector = {
    ANCHOR: 'a',
    ICON: 'wa-icon',
    LABEL: '.nav-label',
} as const

export interface NavEnterpriseMenuItemModel {
    href: string
    label: string
    icon: string
    active: boolean
    target: string
    ariaLabel: string
}

export const NavEnterpriseMenuItemClass = {
    MENU_ITEM: 'nav-enterprise-menu-item',
    LABEL: 'nav-label',
    ACTIVE: 'active',
} as const

export const NavEnterpriseMenuItemTarget = {
    BLANK: '_blank',
    SELF: '_self',
} as const

export const NavEnterpriseMenuItemValues = {
    REL_NOOPENER: 'noopener noreferrer',
    ARIA_CURRENT_PAGE: 'page',
    ARIA_CURRENT_FALSE: 'false',
    ARIA_HIDDEN_TRUE: 'true',
} as const

export const NavEnterpriseMenuItemDefaults: NavEnterpriseMenuItemModel = {
    href: '#',
    label: '',
    icon: '',
    active: false,
    target: '_self',
    ariaLabel: '',
}
